import styled from "styled-components";

export const HeaderInfoContents = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 32px;

  img {
    width: 96px;
    height: 41px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  padding-block: 10px;
  margin-bottom: 20px;

  span {
    margin-top: 20px;
    font-family: "Source Sans Pro";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
  }
`;

export const SuccessMessage = styled.div`
  display: inline-flex;
  width: 100%;
  flex-direction: column;

  p {
    width: 55%;
    align-self: center;
    border-collapse: collapse;

    font-size: 17px;
    line-height: 150%;
    letter-spacing: 0.02em;

    @media screen and (max-width: 799px) {
      width: 90%;
    }

    @media screen and (min-width: 630px) and (max-width: 1000px) {
      width: 70%;
    }

    @media screen and (min-width: 1000px) and (max-width: 1450px) {
      width: 75%;
    }
  }

  p:first-child {
    margin-bottom: 25px;
  }
`;

export const TransactionResponse = styled.div`
  width: 40%;
  border: 1px solid #cbcbcb;
  border-radius: 12px;
  padding: 12px 14px;

  display: flex;
  text-align: center;
  flex-direction: column;
`;